<template>
    <div id="DashBoard">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area pt-0">
            <!-- image slider -->
            <div class="custom-carousel">
                <div class="custom-carousel-track" :style="trackCarouselImageStyle">
                    <div class="custom-carousel-item" v-for="(image, index) in images" :key="index">
                        <a style="cursor: pointer;" @click="goToGetDocumentPath($event, image)" title="View Image">
                            <img :src="imageThumbnails[index]" alt="slider image" />
                        </a>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <!-- user quick buttons -->
                <div class="user-btn-groups mt-2">
                    <div class="user-custom-btns">
                        <span class="custom-text">
                            <span class="custom-text-line1">Customize your own</span>
                            <span class="custom-text-line2">quick link buttons</span>
                        </span>
                        <div class="quick-link-buttons">
                            <template v-for="(userLink, qIndex) in userQuickLinks">
                                <div v-if="userLink === ''" class="custom-dropdown">
                                    <a class="btn-lg custom-btn" role="button" data-toggle="dropdown"
                                        data-toggle-position="left" aria-expanded="false" data-display="static">
                                        <i class="fp-plus"></i>
                                    </a>
                                    <ul id="myDropdown" class="dropdown-menu dropdown-menu-end">
                                        <template v-for="quickLink in quickLinks">
                                            <li @click="assignQuickLink($event, quickLink, 'add', qIndex)"
                                                class="p-2 quick-link-li">{{ quickLink.name }}</li>
                                        </template>
                                    </ul>
                                </div>
                                <div v-else>
                                    <a style="position: relative;overflow: hidden;"
                                        @click="redirectPageUrl(userLink.link)"
                                        class="btn-lg custom-btn custom-btn-quick-link"><b>{{
                                            userLink.name.toUpperCase() }}</b>
                                        <button title="Remove" :ref="'quickLink_' + qIndex"
                                            @click="assignQuickLink($event, userLink, 'remove', qIndex)"
                                            class="icon-remove"><i class="fp-remove"></i></button>
                                    </a>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div class="user-static-btns">
                        <a href="https://www.rizontruck.com/" class="btn-lg custom-btn"
                            target="_blank"><b>RIZONTRUCK.COM</b></a>
                        <a href="https://www.rizontruck.com/find-a-dealer/" class="btn-lg custom-btn"
                            target="_blank"><b>DEALER
                                LOCATOR</b></a>
                        <button data-toggle="modal" data-target="#contactUsModal" class="btn-lg custom-btn"><b>CONTACT
                                US</b></button>
                    </div>
                </div>
                <!-- publication list -->
                <div class="mt-4 color-darkblue">
                    <p class="mb-1" style="font-size: 18px;"><strong>RECENTLY ADDED DOCUMENTS</strong></p>
                    <div style="float: none;" class="admin-page-content publication-list">
                        <section class="internal-container border-top-table-fl mt-0"
                            style="min-height: 440px !important;">
                            <section class="data-table bg-white">
                                <vue-good-table ref="listPublications" title="Publications" :columns="columns"
                                    :rows="rows" :search-options="{
                                        enabled: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'link'">
                                                <a v-on:click="goToGetDocumentPathPublication($event, props.row)"
                                                    title="View Document" href="" style="font-size: 15px;"><i
                                                        class="fp-text-document"></i></a>
                                            </div>
                                            <div v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                            </section>
                        </section>
                    </div>
                </div>
                <!-- news/media gallery section -->
                <div class="mt-3 row" style="display: flex; align-items: stretch;">
                    <div class="col-md-4 col-12">
                        <p class="mb-1 color-darkblue" style="font-size: 18px;"><strong>NEWS & UPDATES</strong></p>
                        <div style="float: none;" class="admin-page-content news-updates h-100">
                            <section class="internal-container border-top-table-fl mt-0 h-100">
                                <h4 class="text-center mt-2">***COMING SOON***</h4>
                                <!-- <div class="news-section mb-2">
                                    <a href="#!">All-electric RIZON Truck Introduces 2 New Models and Enhanced Warranty
                                        for Model Year
                                        2025</a>
                                    <p>11/07/2024</p>
                                </div>
                                <div class="news-section mb-2">
                                    <a href="#!">All-electric RIZON Truck Introduces 2 New Models and Enhanced Warranty
                                        for Model Year
                                        2025</a>
                                    <p>11/07/2024</p>
                                </div>
                                <div class="news-section mb-2">
                                    <a href="#!">All-electric RIZON Truck Introduces 2 New Models and Enhanced Warranty
                                        for Model Year
                                        2025</a>
                                    <p>11/07/2024</p>
                                </div>
                                <div class="news-section mb-2">
                                    <a href="#!">All-electric RIZON Truck Introduces 2 New Models and Enhanced Warranty
                                        for Model Year
                                        2025</a>
                                    <p>11/07/2024</p>
                                </div>
                                <div class="news-section mb-2">
                                    <a href="#!">All-electric RIZON Truck Introduces 2 New Models and Enhanced Warranty
                                        for Model Year
                                        2025</a>
                                    <p>11/07/2024</p>
                                </div>
                                <div>
                                    <button class="custom-btn" type="button"><b>View All Articles</b></button>
                                </div> -->
                            </section>
                        </div>
                    </div>
                    <div class="col-md-3 col-12 mt-md-0 mt-5">
                        <p class="mb-1 color-darkblue" style="font-size: 18px;"><strong>SOCIAL MEDIA</strong></p>
                        <div class="social-media-section p-3 h-100">
                            <p>Follow us on social media to stay up to date on our latest annoucements and specials.</p>
                            <div class="social-media-section-links">
                              <a :href="getValidatedUrl(instaLink, 'instagram')" target="_blank" rel="noopener noreferrer">
                                <i class="fa fa-instagram" aria-hidden="true"></i>
                              </a>
                              <a :href="getValidatedUrl(linkedinLink, 'linkedin')" target="_blank" rel="noopener noreferrer">
                                <i class="fa fa-linkedin" aria-hidden="true"></i>
                              </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 col-12 mt-md-0 mt-5">
                        <p class="mb-1 color-darkblue" style="font-size: 18px;"><strong>MEDIA GALLERY</strong></p>
                        <div style="float: none;" class="admin-page-content media-gallery h-100">
                            <section class="internal-container border-top-table-fl mt-0 h-100">
                                <div class="row" style="height: 400px;overflow: auto;">
                                    <template v-for="(media, index) in allMedias">
                                        <div class="col-md-3 col-6 single-media mb-4 mt-1" :style="getMediaHeight()"
                                            :key="index">
                                            <!-- If the media is an image -->
                                            <a @click="goToGetDocumentPath($event, media)" style="cursor: pointer;"
                                                title="View Image">
                                                <img v-if="isImage(media)" :src="allMediaThumbnails[index]"
                                                    alt="Media Image" class="media-image" />
                                            </a>

                                            <!-- If the media is a video -->
                                            <video v-if="isVideo(media)" controls class="media-video">
                                                <source :src="media" type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    </template>
                                </div>
                                <!-- commented button, no functionality
                                <div>
                                    <button @click="$router.push({ name: 'GalleryList' })" class="custom-btn"><b>View All Photos/Videos</b></button>
                                </div> -->
                            </section>
                        </div>
                    </div>
                </div>
                <!-- Contact Us Modal -->
                <div class="modal fade" id="contactUsModal" tabindex="-1" role="dialog"
                    aria-labelledby="contactUsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                                <img :src="logoPath" alt="Dealer Pro" style="height: 35px; margin-right: 7px">
                                <span
                                    style="font-weight: bold; font-style: italic; color:#012d6b; font-size: 18px;margin-right: 7px">
                                    DealerPro
                                </span>
                                <img :src="flagPath" alt="Country Flag" style="margin-left: 0px; height: 35px">
                            </div>
                            <h4 class="text-center mt-3 mb-3"><b>Contact Us</b></h4>
                            <div class="pl-5 pr-5 mt-1 text-center">
                                <p class="mb-4 text-center" style="font-size: 19px;">If you need support, please
                                    reach out
                                    using the
                                    appropriate department email listed
                                    below. Thank you</p>
                                <h5 class="row">
                                    <span class="col-2"></span>
                                    <span class="col-3 text-left">PARTS</span>
                                    <a style="color: black; text-decoration: underline;" 
                                        :href="'mailto:' + emails.parts">{{ emails.parts }}</a>
                                </h5>

                                <h5 class="row mt-4">
                                    <span class="col-2"></span>
                                    <span class="col-3 text-left">WARRANTY</span>
                                    <a style="color: black; text-decoration: underline;" 
                                        :href="'mailto:' + emails.warranty">{{ emails.warranty }}</a>
                                </h5>

                                <h5 class="row mt-4">
                                    <span class="col-2"></span>
                                    <span class="col-3 text-left">SERVICE</span>
                                    <a style="color: black; text-decoration: underline;" 
                                        :href="'mailto:' + emails.service">{{ emails.service }}</a>
                                </h5>

                                <h5 class="row mt-4">
                                    <span class="col-2"></span>
                                    <span class="col-3 text-left">TRUCK SALES</span>
                                    <a style="color: black; text-decoration: underline;" 
                                        :href="'mailto:' + emails.sales">{{ emails.sales }}</a>
                                </h5>
                            </div>
                            <div class="text-center mt-4 mb-3">
                                <button type="button" data-dismiss="modal" class="btn-lg btn-primary">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../mixins/commonMixins';
import { contractMixins } from '../mixins/contractMixins';
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
import DOMPurify from "dompurify";

Vue.use(VueGoodTable);

export default {
    name: "DashBoard",
    mixins: [commonMixins, contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: true,
        loading: false,
        images: [],
        currentSlide: 0,
        visibleSlides: 5,
        slideInterval: null,
        logoPath: "",
        flagPath: "",
        columns: [
            {
                label: 'Department',
                field: 'department',
                filterable: false,
                hidden: false,
                sortable: false,
                multiple: true,
                fpFieldType: "option",
                filterOptions: {
                    enabled: false,
                    placeholder: "Department",
                    filterValue: '',
                    filterDropdownItems: [],
                    trigger: "enter"
                }
            },
            {
                label: 'Document Title',
                field: 'document_title',
                fpFieldType: "text",
                hidden: false,
                filterable: false,
                sortable: false,
                filterOptions: {
                    enabled: false,
                    placeholder: "Document Title",
                    filterValue: '',
                    filterDropdownItems: [],
                    trigger: "enter"
                },
            },
            {
                label: 'Document Type',
                field: 'document_type',
                fpFieldType: "option",
                hidden: false,
                filterable: false,
                sortable: false,
                multiple: true,
                filterOptions: {
                    enabled: false,
                    placeholder: "Document Type",
                    filterValue: '',
                    filterDropdownItems: [],
                    trigger: "enter"
                },
            },
            {
                label: 'Publication Number',
                field: 'publication_no',
                fpFieldType: "text",
                hidden: false,
                filterable: false,
                sortable: false,
                filterOptions: {
                    enabled: false,
                    placeholder: "Publication Number",
                    filterValue: '',
                    trigger: "enter"
                },
            },
            {
                label: 'Publication Date',
                field: 'publication_date',
                fpFieldType: "date",
                hidden: false,
                filterable: false,
                sortable: false,
                filterOptions: {
                    enabled: false,
                    placeholder: "Publication Date",
                    filterValue: '',
                    trigger: "enter"
                },
            },
            {
                label: 'Documents',
                field: 'link',
                sortable: false,
                filterable: false,
            },
        ],
        rows: [],
        totalRecords: 0,
        userQuickLinks: [],
        quickLinks: [],
        allMedias: [],
        instaLink: '',
        linkedinLink: '',
        imageThumbnails: [],
        allMediaThumbnails: [],
        region: process.env.REGION,
        emailMap: {
            US: {
                parts: "RIZONPARTS@RIZONTRUCK.US",
                warranty: "RIZONWARRANTY@RIZONTRUCK.US",
                service: "SERVICE@RIZONTRUCK.US",
                sales: "SALES@RIZONTRUCK.US"
            },
            CA: {
                parts: "PARTS@RIZONTRUCK.CA",
                warranty: "WARRANTY@RIZONTRUCK.CA",
                service: "SERVICE@RIZONTRUCK.CA",
                sales: "SALES@RIZONTRUCK.CA"
            }
        }
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {

                }
            }
        },
        images: function () {
            this.startAutoSlide();
        },
    },
    computed: {
        trackCarouselImageStyle() {
            // Move by 100% of one image width per slide, based on visible slides
            return {
                transform: `translateX(-${(100 / this.visibleSlides) * this.currentSlide}%)`,
                width: `100%`,
            };
        },
        emails() {
            // Return the emails for the current region, 
            // or fall back to US if region is not defined
            return this.emailMap[this.region] || this.emailMap.US;
        }
    },
    created: function () {
        this.logoPath = process.env.LOGO_PATH;
        this.flagPath = process.env.FLAG_LOGO_PATH;
    },
    beforeDestroy: function () {
        this.stopAutoSlide();
    },
    mounted: function () {
        var self = this;
        self.loadFieldData([
            'quick_links',
            'user_quick_links',
            'social_links'
        ]);

        self.getPermissions();
        self.getPublicationList();
        self.loadMediaGallery();
    },
    methods: {
        nextSlide() {
            if (this.currentSlide < this.images.length - this.visibleSlides) {
                this.currentSlide++;
            } else {
                // Reset to first slide after the last slide is shown
                setTimeout(() => {
                    this.currentSlide = 0;
                }, 500); // Duration of the transition effect
            }
        },
        startAutoSlide() {
            this.slideInterval = setInterval(this.nextSlide, 5000); // Slide every 5 seconds
        },
        stopAutoSlide() {
            clearInterval(this.slideInterval);
        },
        assignQuickLink(event, quickLink, flag, index) {
            event.stopPropagation();
            var self = this;
            var fields = {
                link: quickLink,
                flag: flag,
                id: quickLink.id || 0,
                index: index
            };
            if (flag == 'remove') {
                self.$swal({
                    title: 'Are you sure you want to remove the link?',
                    type: 'warning',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                }).then((result) => {
                    if (result.value) {
                        self.removeButtonFocus(index);
                        self.quickLinkApiRequest(fields);
                    } else {
                        self.$nextTick(() => {
                            self.removeButtonFocus(index);
                        });
                    }
                }).catch(() => {
                    self.$nextTick(() => {
                        self.removeButtonFocus(index);
                    });
                });
            } else {
                self.quickLinkApiRequest(fields);
            }
        },
        removeButtonFocus(index) {
            const button = this.$refs['quickLink_' + index][0];
            if (button) {
                button.style.display = 'none';

                setTimeout(() => {
                    button.style.display = '';
                }, 300);
            }
        },
        quickLinkApiRequest(fields) {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/user/assign-remove-quick-link",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.userQuickLinks = data.content.userQuickLinks;
                    self.quickLinks = data.content.filteredLinks;
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'assign-quick-link');
                }
            });
        },
        getPublicationList() {
            var self = this;
            self.loading = true;
            var fields = {
                flag: 'dashboard'
            };
            $.ajax({
                url: process.env.ROOT_API + "/publication/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'publication-list');
                }
            });
        },
        loadMediaGallery() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/media-gallery/get-all",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.allMedias = data.content.all_media;
                    self.imageThumbnails = data.content.image_thumbnails;
                    self.allMediaThumbnails = data.content.all_media_thumbnails;
                    self.images = data.content.image_slider;
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'load-media-gallery-dashboard');
                }
            });
        },
        goToGetDocumentPathPublication(event, row) {
            event.preventDefault();
            var self = this;
            var path = row.link;
            var flag = 'publication';
            var id = 0;
            if (row.id > 0) {
                id = row.id;
            }
            self.getDocumentPath(id, path, flag);
        },
        // Helper method to check if the URL is an image
        isImage(url) {
            const imageExtensions = ['jpg', 'jpeg', 'png', 'webp'];
            const extension = url.split('.').pop().split('?')[0].toLowerCase();
            return imageExtensions.includes(extension);
        },
        // Helper method to check if the URL is a video
        isVideo(url) {
            const videoExtensions = [
                'mp4',    // .mp4
                'mkv',    // .mkv
                'avi',    // .avi
                'webm',   // .webm
                'ogg',    // .ogv
                'mov',    // .mov
                'flv',    // .flv
                'wmv',    // .wmv
                '3gp',    // .3gp
                'mpeg'    // .mpeg
            ];
            const extension = url.split('.').pop().split('?')[0].toLowerCase();
            return videoExtensions.includes(extension);
        },
        getMediaHeight() {
            // Define aspect ratio for images and videos
            const aspectRatio = 16 / 9; // Default 16:9 for videos and images

            // Assuming the container width is dynamic based on the screen size
            const containerWidth = 200; // This can be adjusted dynamically based on your design

            // Calculate the height based on the width and aspect ratio
            const height = containerWidth / aspectRatio;

            return {
                height: `${height}px`,
            };
        },
        goToGetDocumentPath(event, path) {
            event.preventDefault();
            var self = this;
            var path = path;
            var flag = '';
            var id = 0;

            self.getDocumentPath(id, path, flag);
        },
        validateSocialUrl(url,platform) {
          try {
            const parsedUrl = new URL(url);
            if(platform === "instagram"){
              // Only allow URLs from Instagram with secure protocols
              return ['http:', 'https:'].includes(parsedUrl.protocol) &&
                parsedUrl.hostname === 'www.instagram.com';
            }
            if(platform === "linkedin"){
              // Only allow URLs from Linkedin with secure protocols
              return ['http:', 'https:'].includes(parsedUrl.protocol) &&
                parsedUrl.hostname === 'www.linkedin.com';
            }
          } catch (error) {
            console.error('Invalid URL:', error);
            return false;
          }
        },
        getValidatedUrl(url,platform){
          if (url && url.trim() !== "") {
            // sanitize the URL
            const sanitizedUrl = DOMPurify.sanitize(url);

            // Validate the sanitized URL
            if (this.validateSocialUrl(sanitizedUrl, platform)) {
              return sanitizedUrl;
            }else{
              console.error(`Invalid URL for platform ${platform}:`, url);
            }

            // Fallback to a safe URL (e.g., "#") if invalid
            return '#';
          }else{
            return url;
          }
        }
    }
};
</script>
<style scoped>
/* image slider css */
.custom-carousel {
    position: relative;
    width: 100%;
    overflow: hidden;
}

.custom-carousel-track {
    display: flex;
    transition: transform 0.5s ease;
}

.custom-carousel-item {
    flex: 0 0 20%;
    max-width: 20%;
}

.custom-carousel img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    display: block;
}

/* image slider css end*/
/* buttons group css */
.user-btn-groups {
    display: flex;
    align-items: center;
    gap: 10px;
}

.user-custom-btns {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-basis: 50%;
}

.user-custom-btns .quick-link-buttons {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.user-custom-btns .quick-link-buttons>div {
    flex-grow: 1;
}

.custom-text {
    font-size: 0.9rem;
    color: #636262;
    font-style: italic;
    margin-right: 10px;
    white-space: nowrap;
}

.custom-text-line1,
.custom-text-line2 {
    display: block;
}

.custom-btn {
    background-color: #EF5725;
    color: white;
    height: 50px;
    padding: 0 20px;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    flex-grow: 1;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-btn:hover {
    color: white;
}

.custom-btn:focus,
.custom-btn:active {
    background-color: #EF5725 !important;
}

.custom-btn i {
    font-size: 28px;
    line-height: 1;
}

.divider {
    width: 1px;
    height: 50px;
    background-color: #5f5f5f;
    margin: 0 20px;
}

.user-static-btns {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-grow: 1;
}

.quick-link-li {
    cursor: pointer;
}

.quick-link-li:hover {
    background-color: #FDECE7;
}

.quick-link-buttons .icon-remove {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    background-color: #00000065;
    padding-inline: 15px;
    transform: translateX(110%);
    transition: transform 0.3s ease-in-out;
}

.custom-btn-quick-link:hover .icon-remove {
    transform: translateX(0);
}

.quick-link-buttons .icon-remove i {
    font-size: 20px;
    line-height: unset;
}

.quick-link-buttons .icon-remove:active,
.quick-link-buttons .icon-remove:focus {
    background-color: #00000065 !important;
}

/* buttons group css end*/
/* news section css */
.news-section a {
    font-weight: bold;
    color: black;
    text-decoration: underline;
}

.news-section p {
    font-weight: bold;
    color: #EF5725;
}

/* news section css end*/
/* social media section css end*/
.social-media-section {
    background-color: rgb(43, 43, 43);
    color: white;
    border-radius: 3px;
}

.social-media-section .social-media-section-links {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.social-media-section .social-media-section-links a {
    border: 1px solid white;
    padding: 10px;
    border-radius: 50%;
    height: 45px;
    width: 45px;
}

.social-media-section .social-media-section-links a i {
    color: white;
    font-size: 25px;
}

/* social media section css end*/
/* media gallery section css*/
.single-media {
    position: relative;
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.media-image,
.media-video {
    width: 100%;
    object-fit: cover;
    height: 100%;
}

@media (max-width: 767px) {
    .single-media {
        height: 200px;
    }
}

@media (min-width: 768px) {
    .single-media {
        height: 200px;
    }
}

/* media gallery section css end*/
.custom-dropdown .dropdown-menu {
    position: absolute !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    margin-top: 2px;
    z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue